<section class="dashboard-header">
  <section class="dashboard-header__headings">
    <div class="dashboard-header__headings-container">
      <span class="dashboard-header__headings-text">EPD Analysis of</span>
      <h1 class="dashboard-header__headings-name">{{ productName }}</h1>
    </div>
    @if (standardLogo) {
      <div class="dashboard-header__headings-logo">
        <img [src]="standardLogo" alt="Standard Logo" />
      </div>
    }
  </section>

  <app-epd-dashboard-header-controls
    [selectedPcr]="selectedPcr"
    [dataUpdated]="dataUpdated"
    [selectedMethod]="selectedMethod"
    [methodList]="methodList"
    [pcrList]="pcrList"
    [languages]="languages"
    [selectedLanguage]="selectedLanguage"
    [canPreview]="canPreview"
    [previewButtonLabel]="previewButtonLabel"
    (methodologyChange)="methodologyChange.emit($event)"
    (pcrChange)="pcrChange.emit($event)"
    (languageChange)="languageChange.emit($event)"
    (preview)="preview.emit()"
  ></app-epd-dashboard-header-controls>
</section>
